<template>
  <div class="journal-submit">
    <p class="crumbs">
      <router-link class="color-gray hover-blue" to="/journal"
        >期刊介绍>
      </router-link>
      在线投稿
    </p>
    <div class="title">
      <p class="en">ONLINE SUBMISSION</p>
      <p class="ch">在线投稿</p>
    </div>
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="0px">
      <el-descriptions
        :column="1"
        border
        class="margin-top"
        contentClassName="contentName"
        labelClassName="labelName"
      >
        <el-descriptions-item label="文章标题">
          <el-form-item label="" prop="paperTitle">
            <el-input
              v-model="ruleForm.paperTitle"
              :maxlength="30"
              clearable
              placeholder="请输入文章标题"
            ></el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item label="文章摘要">
          <el-form-item label="" prop="infoAbstract">
            <el-input
              v-model="ruleForm.infoAbstract"
              :autosize="{ minRows: 5, maxRows: 8 }"
              :maxlength="300"
              clearable
              placeholder="请输入文章摘要"
              type="textarea"
            >
            </el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item label="" label-class-name="keywords">
          <template slot="label">
            <p class="required">文章关键字</p>
            <p>(请用 ,隔开)</p>
          </template>
          <el-form-item label="" prop="keyword">
            <el-input
              v-model="ruleForm.keyword"
              :maxlength="100"
              clearable
              placeholder="请输入文章关键字"
            ></el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item label="文章上传路径">
          <el-form-item label="" prop="manuscriptName">
            <el-upload
              :before-upload="beforeUpload"
              :file-list="fileList"
              :limit="1"
              :on-exceed="handleExceed"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              accept=".doc,.docx"
              action="/api/fApi/common/upload"
              class="upload-demo"
              multiple
            >
              <el-button size="small" style="width: 200px" type="primary"
                >选择文件
              </el-button>
              <p class="tip">
                请在上传文件之前确保其已关闭!系统只接收doc,docx格式文件!
                文件最大不能超过4MB!
              </p>
            </el-upload>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item label="知网查重报告" labelClassName="no-require">
          <el-form-item label="" prop="howNet">
            <el-upload
              :before-upload="beforeUpload1"
              :file-list="zwFileList"
              :limit="1"
              :on-exceed="handleExceed"
              :on-remove="handleRemove1"
              :on-success="handleSuccess1"
              accept=".doc,.docx,.pdf"
              action="/api/fApi/common/upload"
              class="upload-demo"
              multiple
            >
              <el-button size="small" style="width: 200px" type="primary"
                >选择文件
              </el-button>
              <p class="tip">
                请在上传文件之前确保其已关闭!系统只接收doc,docx,pdf格式文件!
                文件最大不能超过4MB!
              </p>
            </el-upload>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item label="文章联系人">
          <el-form-item label="" prop="authorName">
            <el-input
              v-model="ruleForm.authorName"
              :maxlength="20"
              clearable
              placeholder="请输入文章联系人"
            ></el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item label="常用电话">
          <el-form-item label="" prop="contactPhone">
            <el-input
              v-model="ruleForm.contactPhone"
              :maxlength="20"
              clearable
              placeholder="请输入常用电话"
            ></el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item label="电子邮箱">
          <el-form-item label="" prop="contactEmail">
            <el-input
              v-model="ruleForm.contactEmail"
              :maxlength="20"
              clearable
              placeholder="请输入电子邮箱"
            ></el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item label="联系单位">
          <el-form-item label="" prop="unitName">
            <el-input
              v-model="ruleForm.unitName"
              :maxlength="100"
              clearable
              placeholder="请输入联系单位"
            ></el-input>
          </el-form-item>
        </el-descriptions-item>
      </el-descriptions>
    </el-form>

    <div class="submit-btns">
      <button class="btn-1" @click="submit">提交</button>
      <button class="btn-2" @click="reset">重置</button>
      <button class="btn-2" @click="back">返回</button>
    </div>
    <!--    成功后提示-->
    <el-dialog
      :before-close="beforeClose"
      :visible.sync="dialogVisible"
      title="感谢您的投稿，请扫描下方二维码添加期刊编辑企业微信"
      width="650px"
    >
      <div class="code-img-v">
        <img alt="" src="@/assets/img/journal/code.png" srcset="" />
      </div>

      <span slot="footer" class="dialog-footer">
        <!--        <el-button @click="dialogVisible = false">取 消</el-button>-->
        <el-button size="small" type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import httpRequest from "@/api/httpRequest";

export default {
  name: "JournalSubmit",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入电话"));
      } else {
        // const reg = /^1[3456789]\d{9}$/;
        const reg = /(^(\d{3,4}-)?\d{7,8})$|(1[3456789]\d{9})/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("电话格式不正确"));
        }
      }
    };
    const validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入电子邮箱"));
      } else {
        // const reg = /^1[3456789]\d{9}$/;
        const reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("电子邮箱格式不正确"));
        }
      }
    };

    return {
      dialogVisible: false,
      action: httpRequest.adornUrl(`/common/upload`),
      ruleForm: {
        paperTitle: "",
        infoAbstract: "",
        keyword: "",
        manuscriptUploading: "", // 稿件
        manuscriptName: "", // 稿件名
        authorName: "",
        contactPhone: "",
        contactEmail: "",
        unitName: "",
        resource: "",
        howNet: null,
      },
      rules: {
        paperTitle: [
          { required: true, message: "请输入文章标题", trigger: "blur" },
        ],
        infoAbstract: [
          { required: true, message: "请输入文章摘要", trigger: "blur" },
        ],
        keyword: [
          { required: true, message: "请输入文章关键字", trigger: "blur" },
        ],
        manuscriptName: [
          {
            required: true,
            message: "请选择文件",
            trigger: "blur",
          },
        ],
        // howNet: [
        //   {
        //     required: true,
        //     message: "请上传知网查重报告",
        //     trigger: "blur",
        //   },
        // ],
        authorName: [
          { required: true, message: "请输入文章联系人", trigger: "blur" },
        ],
        contactPhone: [
          {
            validator: validatePhone,
            trigger: ["blur"],
          },
        ],
        contactEmail: [
          {
            validator: validateEmail,
            trigger: ["blur"],
          },
        ],
        unitName: [
          { required: true, message: "请输入联系单位", trigger: "blur" },
        ],
      },
      fileList: [],
      zwFileList: [],
    };
  },
  mounted() {},
  watch: {
    fileList: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.ruleForm.manuscriptUploading = newVal[0].response.url;
          this.ruleForm.manuscriptName = newVal[0].name;
        } else {
          this.ruleForm.manuscriptUploading = "";
          this.ruleForm.manuscriptName = "";
        }
        this.$refs["ruleForm"].validateField("manuscriptName");
      },
      deep: true,
    },
    zwFileList: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.ruleForm.howNet = JSON.stringify({
            url: newVal[0].response.url,
            name: newVal[0].name,
          });
        } else {
          this.ruleForm.howNet = null;
        }
        // this.$refs["ruleForm"].validateField("howNet");
      },
      deep: true,
    },
  },
  methods: {
    beforeClose() {
      this.dialogVisible = false;
    },
    // 提交
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$request.onlineSubmission(this.ruleForm).then((res) => {
            if (res.code === 200) {
              // this.$message({
              //   message: "提交成功",
              //   type: "success",
              // });
              this.dialogVisible = true;
              this.reset();
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 重置
    reset() {
      this.$refs["ruleForm"].resetFields();
      this.fileList = [];
      this.zwFileList = [];
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleRemove1(file, fileList) {
      this.zwFileList = fileList;
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    // 文件上传成功时的钩子
    handleSuccess1(response, file, fileList) {
      this.zwFileList = fileList;
    },
    // 文件超出个数限制时的钩子
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    beforeUpload(file) {
      const isDoc = file.type === "application/msword";
      const isDocx =
        file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      if (!isDoc && !isDocx) {
        this.$message.error("只能上传doc/docx文件");
        return false;
      }
      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!isLt4M) {
        this.$message.error(`${file.name}文件大小超过 4MB,取消上传!`);
        return false;
      } else {
        return true;
      }
    },
    beforeUpload1(file) {
      console.log(file);
      const isDoc = file.type === "application/msword";
      const isDocx =
        file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const isPdf = file.type === "application/pdf";
      if (!isDoc && !isDocx && !isPdf) {
        this.$message.error("只能上传doc/docx/pdf文件");
        return false;
      }
      // 限制文件大小不超过10MB
      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!isLt4M) {
        this.$message.error(`${file.name}文件大小超过 4MB,取消上传!`);
        return false;
      } else {
        return true;
      }
    },
    // 删除之前
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, fileList);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

.journal-submit {
  width: 1180px;
  margin: 40px auto 0;

  .crumbs {
    font-size: 16px;
    color: #333333;
  }

  .title {
    position: relative;
    height: 102px;
    margin-top: 20px;
    background: #f7f7f7;
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
    display: flex;
    align-items: center;
    justify-content: center;

    .en {
      font-weight: bold;
      font-size: 36px;
      color: #ababab;
      line-height: 24px;
      opacity: 0.2;
    }

    .ch {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, 0);
      font-weight: bold;
      font-size: 30px;
      color: #406cdd;
      line-height: 24px;
    }
  }

  ::v-deep {
    &::selection {
      background: $--color-primary;
      color: #ffffff;
    }

    .el-form-item {
      margin-bottom: 0;
    }

    .el-form-item__label {
      display: none;
    }

    .labelName,
    .no-require,
    .keywords {
      width: 250px;
      font-size: 14px;
      color: #333333;
      text-align: right !important;
      padding-right: 20px !important;
      background: #f7f7f7;
      vertical-align: middle;

      &:before {
        content: "*";
        color: #d44547;
      }
    }

    .keywords,
    .no-require {
      &:before {
        content: "";
      }
    }

    .required {
      &:before {
        content: "*";
        color: #d44547;
      }
    }

    .contentName {
      padding: 20px !important;
    }

    .el-upload {
      text-align: left;
    }
  }

  .btn-upload {
    width: 110px;
    height: 33px;
    background: #406cdd;
    border-radius: 5px;
    font-size: 14px;
    color: #ffffff;
    line-height: 33px;
    border: none;
    cursor: pointer;

    &:active {
      opacity: 0.8;
    }
  }

  .tip {
    margin-top: 10px;
    font-size: 14px;
    color: #fb9218;
    line-height: 24px;
  }

  .submit-btns {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 0 40px;

    .btn-1 {
      width: 220px;
      height: 34px;
      background: #406cdd;
      border: 1px solid #406cdd;
      border-radius: 5px;
      font-size: 14px;
      color: #ffffff;
    }

    .btn-2 {
      width: 83px;
      height: 34px;
      background: #f0f0f0;
      border-radius: 5px;
      border: 1px solid #e0e0e0;
      font-size: 14px;
      color: #333333;
    }

    button {
      line-height: 32px;
      margin: 0 10px;
      cursor: pointer;

      &:active {
        opacity: 0.7;
      }
    }
  }
}

.code-img-v {
  width: 220px;
  height: 220px;
  margin: 0 auto;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
